export class Match {
    protected constructor(
        public sourcePlayer: object | null,
        public targetPlayerId: string | null,
    ) {}
    public isValid(): boolean {
        return this.sourcePlayer !== null && this.targetPlayerId !== null;
    }
    public static init(sourcePlayer: object | null = null, targetPlayerId: string | null = null): Match {
        return new Match(sourcePlayer, targetPlayerId);
    }
}
